export default {
    palette: String | Array, 
    columns: Number, 
    tileSize: Number | Object, 
    value: String, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPalette/ColorPaletteProps.js